import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: {
    en: {
      translations: require('./locales/en/translations.json')
    },
    ru: {
      translations: require('./locales/ru/translations.json')
    },
    es: {
      translations: require('./locales/es/translations.json')
    },
    it: {
      translations: require('./locales/it/translations.json')
    },
    cs: {
      translations: require('./locales/cs/translations.json')
    },
    de: {
      translations: require('./locales/de/translations.json')
    },
    pl: {
      translations: require('./locales/pl/translations.json')
    },
    ro: {
      translations: require('./locales/ro/translations.json')
    },
  },
  ns: ['translations'],
  defaultNS: 'translations'
});

i18n.languages = ['en', 'ru', 'es', 'it', 'cs', 'de', 'pl', 'ro'];

export default i18n;